import DeniedMethodAdvice from 'components/orders/DeniedMethodAdvice/styled';

export default DeniedMethodAdvice;
